/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './main/user/login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { NgxDropzoneModule } from 'ngx-dropzone';  
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { UserModule } from './main/user/user.module';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { MainModule } from './main/main.module';
import { MainRoutingModule } from './main/main-routing.module';
import { ToolModule } from './tool/tool.module';
import { ApiService } from '../app/tool/service/api.service';
import { CurrencyPipe } from '@angular/common';
import { BasicAuthHtppInterceptorService } from './basic-auth-htpp-interceptor.service';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbIconModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbUserModule,
  NbPopoverModule,
  NbTabsetModule,
  NbTooltipModule,
  NbSpinnerModule,

  NbChatModule,
  NbTimepickerModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbToastrModule,
  NbWindowModule,
  NbSidebarModule,
  NbLayoutModule,
} from '@nebular/theme';
import { NbPasswordAuthStrategy, NbAuthModule ,NbAuthJWTToken} from '@nebular/auth';

@NgModule({
  declarations: [
    AppComponent
     ],
  imports: [ 
  
    FormsModule,
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbIconModule,
    NbInputModule,
    NbRadioModule,
    NbSelectModule,
    NbUserModule,
    NbPopoverModule,
    NbTabsetModule,
    NbTooltipModule,
    NbSpinnerModule,
    NgxQRCodeModule,
    NgxDropzoneModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbLayoutModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ToolModule.forRoot(),
    MainModule
   
  ],
  providers: [
    CookieService,
    ApiService,
    {
        
        /*加入此設定*/
      provide: HTTP_INTERCEPTORS, 
      useClass: BasicAuthHtppInterceptorService, 
      multi: true 
    },
    CurrencyPipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
